import { render } from "./NotesPopUp.vue?vue&type=template&id=4cfcb740&scoped=true"
import script from "./NotesPopUp.vue?vue&type=script&lang=js"
export * from "./NotesPopUp.vue?vue&type=script&lang=js"

import "./NotesPopUp.vue?vue&type=style&index=0&id=4cfcb740&lang=css"
import "./NotesPopUp.vue?vue&type=style&index=1&id=4cfcb740&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfcb740"]])

export default __exports__